export default {
    url: '/add',
    template: `
        <user-employee-add user="vm.user"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            countries="vm.countries"
            direct-managers="vm.directManagers">
        </user-employee-add>`,
    resolve: {
        userSites (SiteResource) {
            return SiteResource.userSites({ pageSize: 0 }).$promise;
        },

        directManagers (lodash, UserResource, ROLE_CODE_ENUM, userSites) {
            return UserResource.query({
                roleCode: ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
                'siteIds[]': lodash.map(userSites, 'id')
            }).$promise;
        }
    },
    controller (USER_STATUS_ENUM, CLASSIFIER_ENUM, UserResource, TokenService, classifiers, countries, directManagers) {
        this.user = new UserResource({
            status: USER_STATUS_ENUM.KEYS.ACTIVE,
            'siteIds[]': TokenService.getActiveSiteId(),
            country: TokenService.getCompanyDefaultCountry()
        });
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
        this.countries = countries;
        this.directManagers = directManagers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/employee/add/index.js